import React from 'react';

interface LevelBadgeProps {
  level: number;
  className?: string;
  style?: React.CSSProperties;
}

const toPersianDigits = (num: number) =>
  String(num).replace(/[0-9]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)]);

const LevelBadge: React.FC<LevelBadgeProps> = ({ level, className = '', style }) => (
  <div className={`relative flex items-center justify-center ${className}`} style={style}>
    <div className="relative flex h-full w-full items-center justify-center rounded-full border border-gray-300 bg-white">
      <span className="relative z-10 select-none text-sm font-black text-black sm:text-base">
        {toPersianDigits(level)}
      </span>
    </div>
  </div>
);

export default LevelBadge;
